var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66666 23.7499C1.66416 24.0784 1.79205 24.3945 2.02227 24.6288C2.25249 24.8631 2.56625 24.9966 2.89473 24.9999H17.1053C17.4337 24.9966 17.7475 24.8631 17.9777 24.6288C18.2079 24.3945 18.3358 24.0784 18.3333 23.7499V7.08325H1.66666V23.7499ZM3.33333 8.74992H16.6667V23.3333H3.33333V8.74992Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08335 10.4167H5.41669V20.8334H7.08335V10.4167Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 10.4167H9.16669V20.8334H10.8334V10.4167Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5834 10.4167H12.9167V20.8334H14.5834V10.4167Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 3.75V1.25C13.75 0.549062 13.2558 0 12.625 0H7.375C6.74417 0 6.25 0.549062 6.25 1.25V3.75H0V5.41667H20V3.75H13.75ZM7.91667 1.66667H12.0833V3.75H7.91667V1.66667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.cea0b6a1c8b6959c2b3967a23f4f0b50.svg";
export { ForwardRef as ReactComponent };